import Service from "../service";
import AuthService from "../AuthService";


const User = {
  getAllUser(page) {
    return AuthService.get('/api/get-all-user?page='+page);
  },
  getSearchAllUser(data) {
    return AuthService.get('/api/get-search-all-user?page='+data.page+'&word='+data.word);
  },
  getUser(id) {
    return AuthService.get(`/api/user/${id}`);
  },
  getUserAll() {
    return AuthService.get(`/api/user`);
  },
  saveAccount(data) {
    return AuthService.post('/api/user', data);
  },
  editAccount(data) {
    return AuthService.post('/api/editUser', data);
  },
  deleteAccount(data) {
    return AuthService.post('/api/deleteUser', data);
  },
  searchUser(data) {
    if (data.organitzation_name === undefined) {
      data.organitzation_name = ''
    }
    return AuthService.get('/api/search-user?page='+data.page+'&name='+data.name+'&organitzation_name='+data.organitzation_name);
  },
  searchOrganization(data) {
    return AuthService.get('/api/search-organization?page='+data.page+'&word='+data.word);
  }
};

export default User;
